import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { Box, Chip, Stack } from '@mui/material'

const classes = {
  chip: 'chip',
}
const Root = styled('section')(({ theme }) => ({
  [`& .${classes.chip}`]: {
    height: 'auto',
    lineHeight: '1.5',
    marginLeft: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
  },
  // [`& .${classes.chip} .MuiChip-label`]: {
  // paddingLeft: theme.spacing(0.75),
  // paddingRight: theme.spacing(0.75),
  // },
}))

export default function TableHeaderCell({
  label,
  errorsNumber,
  errorColor,
  filter,
}) {
  return (
    <Root>
      <Stack direction="row" alignItems="center">
        <span>{label}</span>
        {!!errorsNumber && (
          <Chip
            className={classes.chip}
            size="small"
            label={errorsNumber}
            color={errorColor || 'error'}
          />
        )}
      </Stack>
      {filter && (
        <>
          <Box pb={0.5} />
          <div onClick={(e) => e.stopPropagation()}>{filter}</div>
        </>
      )}
    </Root>
  )
}

TableHeaderCell.propTypes = {
  label: T.string,
  errorsNumber: T.number,
  errorColor: T.string,
  filter: T.node,
}
